import * as React from 'react'
import TextContainer from '../layout/TextContainer';


type Props = {

  className?: string
}

const TerminalAllHeuristicsMatchSection: React.FC<Props> = ({ className = '' }) => {

  return (
    <div className={' ' + className}>
      <TextContainer>

        <h2 id="categories" className="text-xl font-bold mb-2 text-gray-800">All heuristics pass - How can I further improve?</h2>
        <p className="pb-2">
          After you passed all node heuristics, the game of climbing the Terminal score rank can be summerized as follow:
        </p>
        <div className="pb-4">
        <p className="pb-1">
          Get as many <span className="font-bold">good peers</span> as possible. You do that by establishing a channel
          to a stable/good node and making sure the channel meets the <a href="#good-channel" className="underline">good channel heuristics</a>.
        </p>
        <p className="">
          Increase your <span className="font-bold">centrality</span>. 
          The lightning network is a mesh of thousands of nodes.
          Do not limit yourself on a specific corner of the network. Create bridges between different node groups.
        </p>
        </div>

        <p>
          The sky is the limit.
        </p>


      </TextContainer>
    </div>
  );
}

export default TerminalAllHeuristicsMatchSection;

